import React, { useState } from 'react';
import { CircularProgress, Paper, useMediaQuery, Select, MenuItem, TextField, Button, Typography, FormControl, InputLabel, makeStyles } from "@material-ui/core";
import config from './config.json';
import { customTheme } from "./customTheme";
import { saveTokens } from './utils/saveTokens';
import notify from './components/CustomUseNotify';
import md5 from 'md5';
import { passwordSalt } from "./sharedData";

const useStyles = makeStyles((theme) => ({
    formControl: {
      marginTop: theme.spacing(2),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  }));

const CreateSubUser = () => {
    const classes = useStyles()
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const [loading, setLoading] = useState(false)
    const [subUserDetails, setSubUserDetails] = useState({username: '', full_name: '', display_name: '', email: '', mobile: '', password: '', confirm_password: ''})
    const [selectedOption, setSelectedOption] = useState("Same")
    const [invalidField, setInvalidField] = useState({})

    const inputHandler = (e, key) =>{
        setSubUserDetails((prev) => {
            return {...prev, [key]: e.target.value}
        })
    }

    const handleChange = (event) => {
        setSelectedOption(event.target.value)
    };

    const fieldValidation = (subUserDetails) => {
        setInvalidField({})
        let validation = false
        for (const key in subUserDetails) {
            if (subUserDetails[key] === '') {
                validation = true
                setInvalidField((prev) => {
                    return {...prev, [key]: key}
                })
            }
        }
        if (subUserDetails['password'] !== subUserDetails['confirm_password']) {
            validation = true
            setInvalidField((prev) => {
                return { ...prev, password: 'password', confirm_password: 'confirm_password' }
            })
        }
        if(subUserDetails['mobile'] && subUserDetails['mobile'].search(/^\d{10}$/g) === -1) {
            validation = true
            setInvalidField((prev) => {
                return { ...prev, mobile: 'mobile' }
            })
        }
        return validation
    }

    const onCreateSubUser = () => {
       if(fieldValidation(subUserDetails)) return
        setInvalidField({})
        setLoading(true)
        delete subUserDetails['confirm_password'];
        const params = {
            ...subUserDetails,
            user_id: sessionStorage.getItem("user_id"),
            permission: selectedOption,
            password :  md5(subUserDetails.password + passwordSalt)
        };
        fetch(`${config.HOST_NAME}/crm/v3/createSubUser`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
            body: JSON.stringify(params)
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                if (json.success) {
                    setSubUserDetails({username: '', full_name: '', display_name: '', email: '', mobile: '', password: '', confirm_password: ''})
                    notify('Successfully Created Sub User', "success")
                }
                else notify(json.message, "warning");
            })
            .catch(error => {
                console.log(error)
                notify('Something Went Wrong', 'warning');
            })
            .finally(() =>{
                setLoading(false)
            })
    }


    return (
        <Paper style={{ padding: isSmallDevice ? "0 22px 100px" : "0px 22px 100px 22px", boxShadow: isSmallDevice ? "none" : undefined, marginTop: 10, position:'relative' }} >
            <Typography style={{marginTop: 20, marginBottom: 20}}>Sub User Details</Typography>
            <div className="grid-250" style={{ rowGap: 20}}>
                <TextField variant="outlined" size="small" label="Username" value={subUserDetails.username} onChange={(e) => inputHandler(e, 'username')} error={invalidField && invalidField['username'] ? true : false}/>
                <TextField variant="outlined" size="small" label="Full Name" value={subUserDetails.full_name} onChange={(e) => inputHandler(e, 'full_name')} error={invalidField && invalidField['full_name'] ? true : false}/>
                <TextField variant="outlined" size="small" label="Display Name" value={subUserDetails.display_name} onChange={(e) => inputHandler(e, 'display_name')} error={invalidField && invalidField['display_name'] ? true : false}/>
                <TextField variant="outlined" size="small" label="Email" value={subUserDetails.email} onChange={(e) => inputHandler(e, 'email')} error={invalidField && invalidField['email'] ? true : false}/>
                <TextField variant="outlined" size="small" label="Mobile" value={subUserDetails.mobile} onChange={(e) => inputHandler(e, 'mobile')} error={invalidField && invalidField['mobile'] ? true : false}/>
                <TextField variant="outlined" size="small" label="Password" type='password' value={subUserDetails.password} onChange={(e) => inputHandler(e, 'password')} error={invalidField && invalidField['password'] ? true : false}/>
                <TextField variant="outlined" size="small" label="Confirm Password" type='password' value={subUserDetails.confirm_password} onChange={(e) => inputHandler(e, 'confirm_password')} error={invalidField && invalidField['confirm_password'] ? true : false}/>
            </div>

            <div className="grid-250" style={{ marginTop: 8 }}>
                <FormControl variant="outlined" className={classes.formControl}>
                    <InputLabel id="demo-simple-select-outlined-label">Role</InputLabel>
                    <Select
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        value={selectedOption}
                        onChange={handleChange}
                        label="Role"
                    >
                        <MenuItem value="Same">Same</MenuItem>
                        <MenuItem value="View Only">View Only</MenuItem>
                    </Select>
                </FormControl>
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', position:'absolute', left: 0, right: 0, bottom: 0, padding: 16, zIndex: 2, backgroundColor: '#F5F5F5' }}>
                <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
                    <Button
                        onClick={onCreateSubUser}
                        color="primary"
                        variant="contained"
                        style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#18CC69", color: "#FFF" }}
                        disableElevation
                        disabled={loading}
                    >
                        Save
                        {loading && <CircularProgress size={16} color='#FFFFFF' style={{marginLeft: 5}} />}
                    </Button>
                </div>
            </div>
        </Paper>
    )

}
export default CreateSubUser